module.exports = __webpack_public_path__ + "static/media/program-14.97462e87.webp";